import { laptopMediumMax, mobileXXLargeMax, laptopMinXL } from '@propertypal/shared/src/constants/mediaQueries';
import StarBurst from '@propertypal/shared/src/resources/icons/home/starburst-icon.svg';
import CloseToSearchIcon from '@propertypal/shared/src/resources/icons/search/close-to-prompt.svg';
import Link from 'next/link';
import styled from 'styled-components';
import { MAX_WIDTH } from '../layout/PageWrapper.style';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  padding: 0 20px;
  width: 100%;
  max-width: ${MAX_WIDTH - 20}px;
  margin: 30px auto;

  @media (${laptopMediumMax}) {
    padding: 0 15px;
    flex-direction: column;
  }
`;

export const SearchBox = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;

  h1 {
    position: relative;
    font-weight: 600;
    font-size: 30px;
    color: ${({ theme }) => theme.textDark};
    z-index: 2;
  }

  @media (${laptopMediumMax}) {
    h1 {
      text-align: center;
    }
  }

  @media (${mobileXXLargeMax}) {
    h1 {
      font-size: 25px;
    }
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  margin: 15px 0;
  border: 1px solid ${({ theme }) => theme.keyline};
  border-radius: 5px;
`;

export const StarBurstIcon = styled(StarBurst)`
  position: absolute;
  top: -16px;
  left: -24px;
  z-index: -1;

  @media (${laptopMediumMax}) {
    display: none;
  }
`;

export const SlideShowBox = styled.div`
  min-width: 60%;
  max-width: 700px;
  height: 480px;
  overflow: hidden;
  border-radius: 5px;

  .swiper-button-next,
  .swiper-button-prev {
    color: ${({ theme }) => theme.white};
  }

  @media (${laptopMediumMax}) {
    max-width: 100%;
    height: 400px;
  }
`;

export const SlideShowImage = styled(Link)<{ $url: string }>`
  display: block;
  background: url(${({ $url }) => $url});
  background-size: cover;
  background-position: center;
  height: 480px;

  @media (${laptopMediumMax}) {
    height: 400px;
  }
`;

export const SlidePropertyDetails = styled.div`
  position: absolute;
  right: 12px;
  bottom: 12px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.background};
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  max-width: calc(100% - 30px);

  img {
    height: 44px;
  }
`;

export const AccountLogo = styled.div`
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

export const SliderTextBox = styled(Link)`
  display: block;
  line-height: 1;
  max-width: 230px;

  &:hover {
    text-decoration: underline;
  }
`;

export const TabRow = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.textDark};
  display: flex;
`;

export const TabItem = styled.button<{ $active?: boolean }>`
  flex: 1;
  font-size: 21px;
  padding: 10px 0;
  margin-bottom: -1px;
  color: ${({ $active, theme }) => ($active ? theme.primary : theme.textDark)};
  font-weight: ${({ $active }) => ($active ? 'bold' : 'normal')};
  border-bottom: ${({ $active, theme }) => ($active ? `4px solid ${theme.primary}` : '4px solid rgba(0,0,0,0)')};

  &:hover {
    color: ${({ theme }) => theme.primary};
  }

  @media (${mobileXXLargeMax}) {
    font-size: 18px;
  }
`;

export const CloseToContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;

  > :not(:last-child) {
    margin-right: 16px;
  }

  @media (${laptopMinXL}) {
    padding: 16px;
  }
`;

export const CloseToIconWrapper = styled.div`
  height: auto;
`;

export const CloseToIcon = styled(CloseToSearchIcon)`
  width: 70px;
  height: 70px;
`;

export const CloseToContent = styled.div`
  flex: 1 1 auto;
  font-size: 17px;
`;

export const CloseToTrigger = styled.button`
  color: inherit;
  font-size: inherit;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  transition: color linear 150ms;

  &:hover {
    color: ${({ theme }) => theme.primary};
  }

  > :not(:last-child) {
    margin-right: 8px;
  }
`;

export const CloseToTriggerWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 16px;
  row-gap: 8px;
`;
